import { Types } from '@store/types';

const initialState = {
	searchKey: '',
	isShowFilter: false,
	showDetailsPage: false
};

const MyColleaguesReducer = (state = initialState, action) => {
	switch (action.type) {
		case Types.TOGGLE_MY_COLLEAGUES_FILTER:
			return {
				...state,
				isShowFilter: action.payload
			};
		case Types.STORE_MY_COLLEAGUES_SEARCH_KEY:
			return {
				...state,
				searchKey: action.payload
			};
		case Types.SHOW_MY_COLLEAGUES_DETAILS_PAGE:
			return {
				...state,
				showDetailsPage: action.payload
			};
		default:
			return state;
	}
};

export default MyColleaguesReducer;
